import React from "react";

export const ErrorField = ({ error }) => {
  return error ? (
    <p className="text-medium text-danger m-0" style={{ marginTop: 2 }}>
      *{error?.toString()}
    </p>
  ) : (
    ""
  );
};
